"use strict";
import angular from "angular";

import sitzungsmodule from "dias/sitzungen/sitzungsmodule";

import detail from "./detail.component";
import preview from "./preview.component";

const modul = angular.module("standard_sitzungsmodule.manuelle_antragsliste", [
  sitzungsmodule.name,
])

  .config(/*@ngInject*/SitzungsmodulRegistryProvider => {
    SitzungsmodulRegistryProvider.register("manuelle_antragsliste", "modul-manuelle-antragsliste", "modul-manuelle-antragsliste-preview");
  })

  .component("modulManuelleAntragsliste", detail)
  .component("modulManuelleAntragslistePreview", preview)
;

export default modul;
